import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = (theme) => ({
  root: {
    textAlign: 'left',
  },
  listItem: {
    display: 'flex',
    paddingBottom: theme.spacing(1),
  },
  bullet: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    flexShrink: 0,
    fontSize: theme.typography.body1.fontSize,
    borderRadius: theme.spacing(1.5),
    backgroundColor: theme.palette.facet.accentBlue11,
    color: '#FFF',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: `${theme.spacing(3)}px`,
    marginRight: theme.spacing(1),
  },
});

const BulletList = ({
  className,
  classes,
  listItems,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {listItems.map((li, i) => {
        return (
          <div
            className={classes.listItem}
            key={i} // eslint-disable-line react/no-array-index-key
          >
            <div className={classes.bullet}>
              {i + 1}
            </div>
            {(typeof li === 'string') ? (
              <Typography variant={'body1'} color={'primaryGray'}>{li}</Typography>
            ) : { li }}
          </div>
        );
      })}
    </div>
  );
};

BulletList.defaultProps = {
  className: '',
};

BulletList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  listItems: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired,
};

export default withStyles(styles)(BulletList);
